
import { Checkbox } from '05-ui-kit';
import { computed } from '@nuxtjs/composition-api';
import GiftItem from '../GiftItem/GiftItem.vue';
import LazyImg from '../LazyImg/LazyImg.vue';
import SaleMarkerList from '../SaleMarkerList/SaleMarkerList.vue';
import type { CartProduct } from '~/type/product/Product';
import TSPrice from '~/components/ts-components/TSPrice/TSPrice.vue';
import TSBonusCount from '~/components/ts-components/TSBonusCount/TSBonusCount.vue';
import TSCounter from '~/components/ts-components/TSCounter/TSCounter.vue';
import ActionCart from '~/action/ActionCart.vue';
import ActionFavorite from '~/action/ActionFavorite.vue';
import { useUserStore } from '~/store/user';
const __sfc_main = {};
__sfc_main.props = {
  product: {
    key: "product",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const userStore = useUserStore();
  const isUser = computed(() => userStore.isUser);
  const isUnavailable = computed<boolean>(() => props.product.status.code === 'NOT_AVAILABLE');
  const cartProductPrice = computed(() => {
    return {
      ...props.product.price!,
      common: {
        ...props.product.price?.common,
        value: props.product.price?.common?.value ? props.product.price?.common?.value * props.product.quantity : 0
      },
      discount: {
        ...props.product.price?.discount,
        value: props.product.price?.discount ? props.product.price?.discount?.value * props.product.quantity : 0
      }
    };
  });
  return {
    emit,
    isUser,
    isUnavailable,
    cartProductPrice
  };
};
__sfc_main.components = Object.assign({
  ActionCart,
  Checkbox,
  TSBonusCount,
  LazyImg,
  TSPrice,
  SaleMarkerList,
  ActionFavorite,
  TSCounter,
  GiftItem
}, __sfc_main.components);
export default __sfc_main;
